module.exports = __webpack_public_path__ + "static/media/search_home_tabs.4fc6cf3a.png";